/** @jsx jsx */
import {jsx, css} from '@emotion/react'

import Button from '../../button'
import StartpageLogo from '../../../images/startpage-logo-new.svg'

const Header = ({onLogoClick, onCtaClick}) => {
    const onKeyUp = (e) => {
        if (e.keyCode === 13) {
            onLogoClick()
        }
    }
    return (
        <header
            css={css`
                background: #fafbfd;
                padding: 1.5rem 1rem;
            `}
        >
            <div
                css={css`
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    max-width: 800px;
                    margin: auto;
                    @media (max-width: 600px) {
                        flex-direction: column;
                    }
                `}
            >
                <div onClick={onLogoClick} onKeyUp={onKeyUp} role="button" tabIndex={0}>
                    <StartpageLogo
                        css={css`
                            width: 162px;
                            height: 41px;
                            &:hover {
                                cursor: pointer;
                            }
                        `}
                    />
                </div>
                <Button
                    overrideStyles="
                        button {
                            margin: 0;
                        }
                        @media (max-width: 600px) {
                            margin-top: 1rem;
                        }
                    "
                    text="Search In Private"
                    onClick={onCtaClick}
                />
            </div>
        </header>
    )
}

export default Header
